<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('直播人昵称')" prop="nickName">
                <a-input v-model="queryParam.nickName" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('直播人昵称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('直播主题')" prop="theme">
                <a-input v-model="queryParam.theme" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('直播主题')" allow-clear/>
              </a-form-item>
            </a-col>
            <!--            <a-col :md="6" :sm="24">-->
            <!--              <a-form-item :label="$t('直播状态')" prop="status">-->
            <!--                <a-select :placeholder="$t('通用.输入.请选择')+$t('直播状态')" style="width: 100%" v-model="queryParam.status"-->
            <!--                          allowClear>-->
            <!--                  <a-select-option v-for="(item, index) in customDict.LiveStatusEnum" :value="item.type" :key="index">-->
            <!--                    {{ item.name }}-->
            <!--                  </a-select-option>-->
            <!--                </a-select>-->
            <!--              </a-form-item>-->
            <!--            </a-col>-->

            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>

              </span>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createFormLive.handleAdd()" v-hasPermi="['live:live:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['live:live:edit']">-->
        <!--          <a-icon type="edit" />{{$t('通用.按钮.修改')}}-->
        <!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['live:live:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <create-form-live ref="createFormLive" @ok="getList"/>

      <!-- 分享 -->
      <create-form-share
        ref="createFormShare"
        @ok="getList"
      />
        <create-form-red-packet ref="createFormRedPacket"  @ok="getList"/>
      <create-form-coupon ref="createFormCoupon"  @ok="getList"/>
      <create-form-goods ref="createFormGoods"  @ok="getList"/>
      <create-form-lottery ref="createFormLottery"  @ok="getList"/>
      <create-form-red-packet-record ref="createFormRedPacketRecord"   @ok="getList"/>
      <create-form-lottery-record ref="createFormLotteryRecord"   @ok="getList"/>
      <live-operation-modal ref="liveOperationModal" @ok="getList"/>
      <edit-live-theme ref="editLiveTheme" @ok="getList"/>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :bordered="tableBordered"
      >
        <span slot="openTime" slot-scope="text, record">
          {{ parseTime(record.openTime) }}
        </span>
        <template slot="thumb" slot-scope="text, record">
          <div>
            <img v-if="record.thumb" :src="record.thumb"  style="width:60px;height:62px;" @click="handleRecordPreview(record.thumb)" alt="none"/>
          </div>
        </template>
        <span slot="closeTime" slot-scope="text, record">
          {{ parseTime(record.closeTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.LiveStatusEnum" :value="record.status"/>
        </span>
        <span slot="expiredTime" slot-scope="text, record">
          {{ parseTime(record.expiredTime) }}
        </span>
        <span slot="errorCloseTime" slot-scope="text, record">
          {{ parseTime(record.errorCloseTime) }}
        </span>
        <span slot="redPacketExpiredTime" slot-scope="text, record">
          {{ parseTime(record.redPacketExpiredTime) }}
        </span>
        <span slot="redPacketBeginTime" slot-scope="text, record">
          {{ parseTime(record.redPacketBeginTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
            <a @click="$refs.editLiveTheme.handleEdit(record)" v-hasPermi="['live:live:edit']">
                  <a-icon type="edit" />{{$t('通用.按钮.修改')}}
                </a>
            <a-divider type="vertical" v-hasPermi="['live:live:edit']" />
            <a @click="$refs.liveOperationModal.handleLiveData(record)"  >
                  <a-icon type="edit" />{{$t('操作')}}
                </a>

          <a-divider type="vertical" v-hasPermi="['live:live:queryquery']" />
          <a @click="$refs.createForm.handleLiveData(record, undefined)" v-hasPermi="['live:live:queryquery']">
             <a-icon type="edit" />{{$t('详情')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['live:live:shareshare']"  />
          <a @click="$refs.createFormShare.handleShare(record)"  v-hasPermi="['live:live:shareshare']" >
            <a-icon type="edit" />{{$t('分享')}}
          </a>
<!--          <a-divider type="vertical" v-hasPermi="['live:live:remove']" />-->
<!--          <a-dropdown>-->
<!--            <a class="ant-dropdown-link">-->
<!--              <a-icon type="double-right" />-->
<!--              {{$t('更多')}}-->
<!--            </a>-->

<!--            <a-menu slot="overlay">-->
<!--              <a-menu-item >-->
<!--                <a @click="$refs.createFormRedPacket.handleAdd(record)"  v-hasPermi="['live:live:redpacket']" >-->
<!--                  <a-icon type="edit" />{{$t('发红包')}}-->
<!--                </a>-->
<!--                  <a @click="$refs.createFormRedPacketRecord.handleLiveData(record)"  v-hasPermi="['live:live:redpacket']" >-->
<!--                  <a-icon type="edit" />{{$t('红包领取列表')}}-->
<!--                </a>-->
<!--                  <a @click="$refs.createFormCoupon.handleAdd(record)"  v-hasPermi="['live:live:addcoupon']" >-->
<!--                  <a-icon type="edit" />{{$t('发优惠券')}}-->
<!--                </a>-->

<!--                  <a @click="$refs.createFormGoods.handleUpdate(record)"  v-hasPermi="['live:live:addgoods']" >-->
<!--                  <a-icon type="edit" />{{$t('上架商品')}}-->
<!--                </a>-->

<!--                  <a @click="$refs.createFormLottery.handleUpdate(record)"  v-hasPermi="['live:live:choujiang']" >-->
<!--                  <a-icon type="edit" />{{$t('创建抽奖')}}-->
<!--                </a>-->
<!--                  <a @click="$refs.createFormLotteryRecord.handleLiveData(record)"  v-hasPermi="['live:live:choujiang']" >-->
<!--                  <a-icon type="edit" />{{$t('抽奖列表')}}-->
<!--                </a>-->
<!--              </a-menu-item>-->

<!--            </a-menu>-->
<!--          </a-dropdown>-->




        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageLive,listLive, delLive ,endLive,startLive} from '@/api/live/live'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateFormShare from './modules/CreateFormShare'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import CreateFormLive from "@/views/live/live/modules/CreateFormLive.vue";
import CreateFormRedPacket from "@/views/live/live/modules/CreateFormRedPacket.vue";
import CreateFormRedPacketRecord from "@/views/live/live/modules/CreateFormRedPacketRecord.vue";
import CreateFormCoupon from "@/views/live/live/modules/CreateFormCoupon.vue";
import CreateFormGoods from "@/views/live/live/modules/CreateFormGoods.vue";
import CreateFormLottery from "@/views/live/live/modules/CreateFormLottery.vue";
import CreateFormLotteryRecord from "@/views/live/live/modules/CreateFormLotteryRecord.vue";
import LiveOperationModal from './modules/LiveOperationModal.vue'
import EditLiveTheme from './modules/EditLiveTheme.vue'

export default {
  name: 'Live',
  components: {
    CreateFormLotteryRecord,
    CreateFormLottery,
    CreateFormGoods,
    CreateFormCoupon,
    CreateFormRedPacketRecord,
      CreateFormRedPacket,
    CreateFormShare,
    CreateFormLive,
    CustomDictTag,
    CreateForm,
    LiveOperationModal,
    EditLiveTheme
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        imGroupId: undefined,
        userId: undefined,
        shopId: undefined,
        shopName: undefined,
        shopLogo: undefined,
        thumb: undefined,
        theme: undefined,
        intro: undefined,
        liveName: undefined,
        openTime: undefined,
        closeTime: undefined,
        expiredTime: undefined,
        effective: undefined,
        duration: undefined,
        pushUrl: undefined,
        pullUrl: undefined,
        chatNum: undefined,
        totalMoney: undefined,
        status: undefined,
        cutInfo: undefined,
        shareInfo:{
        },
        isErrorClose: undefined,
        errorCloseTime: undefined,
        classifyId: undefined,
        liveType: undefined,
        liveAddress: undefined,
        liveCityName: undefined,
        redPacketExpiredTime: undefined,
        redPacketBeginTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('直播人昵称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('封面'),
          dataIndex: 'thumb',
          scopedSlots: { customRender: 'thumb' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('主题'),
          dataIndex: 'theme',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('预约开启时间'),
          dataIndex: 'preOpenTime',
          scopedSlots: { customRender: 'preOpenTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('开启时间'),
          dataIndex: 'openTime',
          scopedSlots: { customRender: 'openTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('直播关闭时间'),
          dataIndex: 'closeTime',
          scopedSlots: { customRender: 'closeTime' },
          ellipsis: true,
          align: 'center'
        },



        {
          title: this.$t('直播状态'),
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          customRender: function (v) {
            if (v == 1) {
              return "未开播";
            }else if (v == 2){
              return '已开播';
            } else if (v == 3){
              return '直播结束';
            }
          }

        },
        {
          title: this.$t('是否可以回放'),
          dataIndex: 'isPlayback',
          ellipsis: true,
          align: 'center',
          customRender: function (v) {
            if (v == 1) {
              return "是";
            }else {
              return '否';
            }
          }

        },

        {
          title: this.$t('是否推流'),
          dataIndex: 'isTl',
          ellipsis: true,
          align: 'center',
          customRender: function (v) {
            if (v == 1) {
              return "是";
            } else {
              return '否';
            }
          }
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('备注'),
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 关闭直播 */
    handleStart (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let param = {};
      param.id = ids;
      startLive(param).then(response => {
        this.$message.success(
          '开启成功',
          3
        )
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
        this.getList();
      })
    },
    /** 关闭直播 */
    handleClose (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let param = {};
      param.id = ids;
      endLive(param).then(response => {
        this.$message.success(
          '关闭成功',
          3
        )
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
        this.getList()
      })
    },

    /** 查询直播列表 */
    getList () {
      this.loading = true
      pageLive(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        imGroupId: undefined,
        userId: undefined,
        shopId: undefined,
        shopName: undefined,
        shopLogo: undefined,
        thumb: undefined,
        theme: undefined,
        intro: undefined,
        liveName: undefined,
        openTime: undefined,
        closeTime: undefined,
        expiredTime: undefined,
        effective: undefined,
        duration: undefined,
        pushUrl: undefined,
        pullUrl: undefined,
        chatNum: undefined,
        totalMoney: undefined,
        status: undefined,
        cutInfo: undefined,
        isErrorClose: undefined,
        errorCloseTime: undefined,
        classifyId: undefined,
        liveType: undefined,
        liveAddress: undefined,
        liveCityName: undefined,
        redPacketExpiredTime: undefined,
        redPacketBeginTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delLive(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      var param = this.queryParam;
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('live/live/export',
            param
            , `直播_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
